<template>
      <div
        class="modal right fade trader-info"
        id="trader-info"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"       
      >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title mr-auto p-2" >{{offerProp.cusip}}</h5> 
              <button type="button" class="close" @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
          </button>

            </div>
            <div class="modal-body table-responsive">
                <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                <table class="table align-items-center table-flush table-hover bidtbl  ">
                    <thead class="thead-light psticky">
                    <tr>
                        <th scope="col" class="text-center">SELECT</th>
                        <th scope="col" class="text-center">ECN</th>
                        <th scope="col" class="text-center">PRICE</th>
                        <th scope="col" class="text-center">QTY/MIN</th>
                        <th scope="col" class="text-center">SETTLEMENT</th>
                        <th scope="col" class="text-center">COST</th>
                        <th scope="col" class="text-center">SOURCE</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="offers.length == 0 && !loading">
                        <td><p class="nodata">No data available</p>
                        </td>
                    </tr>
                    <tr v-for="offer in offers" :key="offer.id">
                        <td v-if="offer.offerSource == 'IMS'">
                            <input 
                                type="radio" 
                                class="form-check-input cursor-pointer"
                                :value="offer.imsOfferId" 
                                v-model="selectedOffer" 
                                :disabled="offer.imsOrRetail && offer.offerSource !== 'IMS'"
                                @change="addtoList(offer)"
                            />
                        </td>
                        <td v-else>
                            <input 
                                type="radio" 
                                class="form-check-input cursor-pointer"
                                :value="offer.id" 
                                v-model="selectedOffer" 
                                :disabled="offer.imsOrRetail && offer.offerSource !== 'IMS'"
                                @change="addtoList(offer)"
                            />
                        </td>
                        <td><span>{{offer.ecn}}</span></td>
                        <td><span>{{offer.askPx}}</span></td>
                        <td><span>{{offer.askQty}} / {{offer.minQty ? offer.minQty : "N/A"}}  </span></td>
                        <td><span>{{offer.settlementDate ? moment(offer.settlementDate).format("MM/DD/YYYY"): ''}}</span></td>
                        <td><span>{{offer.cost | currency}}</span></td>
                        <td><span>{{offer.offerSource}}</span></td>
                        
                    </tr>
                    </tbody>
                </table>
            </div>
          </div>
        </div>
      </div>
</template>

<script>
    import authService from "@/authService";
    import config from "@/config";
    export default {
        name: 'customerEmails',
        components :{
            
        },
        props: ['offerProp'],
        data() {
            return {
                loading : false,
                offers : [],  
                selectedOffer: null,    
            }
        },
        methods: {
            addtoList(offer){
                offer.changeOfferId = this.offerProp.id;
                this.$root.$emit("offerchange",offer);  
                this.$emit('close');
            },  
            getOffers(){
                this.loading = true;
                const auth = {
                    headers: { 'org-token' : authService.getOrgToken() }
                };
                this.$http
                .get(
                config.baseUrlAutoBidder +
                    "/offering-feed/cusip-offers?cusip="+this.offerProp.cusip,
                    auth
                )
                .then(result => {
                    this.offers = result.data;
                    this.loading = false;
                })
            }

        },
        mounted(){
          this.selectedOffer =  this.offerProp.isIMSofferSelect ?  this.offerProp.imsOfferId  :   this.offerProp.id
          console.log(this.selectedOffer)
          console.log(this.selectedOffer)
          this.getOffers();
        }
    };
    </script>